export default __webpack_public_path__ + "static/Image043_small-1be1babce9fd6227cc17fce927097fa5.png";